import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { filterRelatedAlerts } from '../utils/alerts'
import { bp } from '../globalStyles'
import { Page, Container } from '../components/common'
import Meta from '../components/Meta'
import Schema from '../components/Schema'
import Header from '../components/Header'
import TextCard from '../components/TextCard'
import InfoPageCard from '../components/InfoPageCard'
import SectionTitle from '../components/SectionTitle'
import FeatureGrid from '../components/FeatureGrid'
import AlertCard from '../components/AlertCard'

const LearnMoreSection = styled.section`
  @media (${bp.desktop}) {
    display: none;
  }
`
const HomeHeader = styled(Header)`
  @media (${bp.desktop}) {
    margin-bottom: 2.5rem;
  }
`

const Home = ({
  page,
  locations,
  glossary,
  infoPages,
  alerts,
  linkContentRelations,
  ...props
}) => {
  if (!page) return null

  return (
    <Page>
      <HomeHeader
        title={page.fields.title}
        images={page.fields.headerImages}
        large
      />
      <Meta
        geo={null}
        title={page.fields.title}
        url='https://discoverspringbrook.com'
        description={page.fields.description}
      />
      <Schema
        type='Place'
        publicAccess
        description={page.fields.description}
        url='https://discoverspringbrook.com'
        name='Springbrook National Park'
        sameAs='https://en.wikipedia.org/wiki/Springbrook_National_Park'
      />
      <Container desktopOnly>
        {page.fields.description && (
          <TextCard content={linkContentRelations(page.fields.description)} />
        )}
        {filterRelatedAlerts({ alerts }).map(alert => (
          <AlertCard key={`AlertCard-${alert.id}`} {...alert} />
        ))}
        {!!locations.length && <SectionTitle title='Highlights' />}
        <FeatureGrid type='locations' locations={locations} />
        <LearnMoreSection>
          <SectionTitle title='Learn More' />
          {glossary.length > 0 && (
            <InfoPageCard title='Glossary' to='/glossary' />
          )}
          {infoPages &&
            infoPages.map(infoPage => (
              <InfoPageCard
                key={`InfoPageCard-${infoPage.fields.slug}`}
                title={infoPage.fields.title}
                subtitle={infoPage.fields.subtitle}
                to={`/${infoPage.fields.slug}`}
              />
            ))}
        </LearnMoreSection>
      </Container>
    </Page>
  )
}

Home.propTypes = {
  locations: PropTypes.array.isRequired,
  pages: PropTypes.array.isRequired
}

export default Home



// WEBPACK FOOTER //
// ./src/views/Home.js